import { useCallback, useState } from 'react';
import { navStatusList, pageStatusList } from '../utils/page';
import { useScheduler } from './useScheduler';
import useSubLine from './useSubLine';

const searchInterval = 1000 * 60 * 60;

export const useNavbar = () => {
	const [pageStatus, setPageStatus] = useState(pageStatusList);

	const setNeedCheckedStatus = useCallback((value, page) => {
		if (!value || !pageStatusList[page]) return;
		setPageStatus((info) => ({ ...info, [page]: navStatusList.needChecked }));
	}, []);

	const { exist } = useSubLine({});

	const checkSubLineRequisitions = useCallback(
		() => exist((value) => setNeedCheckedStatus(value, 'subLineRequisitions')),
		[exist, setNeedCheckedStatus]
	);

	useScheduler(checkSubLineRequisitions, searchInterval);

	return { pageStatus };
};
